module.exports = __webpack_public_path__ + "static/media/img_solution_one.99adeabf.png";